<script>
export default {
  name: 'NotFound'
}
</script>

<template>
  <div class="container mt-5 text-center">
    <h1 class="text-secondary">404 - Page Not Found</h1>
    <p>The requested page could not be found.</p>
    <router-link :to="{ name: 'home' }" class="mt-5 ff-regular">return to Home</router-link>
  </div>
</template>

